// Z34/Z50.3: renders the viewport-fixed mirrored scrollbar for useStickyHScroll (see that
// hook for why fixed positioning, not sticky). Render once per table, anywhere in the page.
export function StickyHScrollbar({
  hasHScroll, scrollWidth, mirrorRef, onScroll, fullWidth,
}: {
  hasHScroll: boolean
  scrollWidth: number
  mirrorRef: React.RefObject<HTMLDivElement | null>
  onScroll: () => void
  // For pages whose content spans the full viewport width instead of the centred `container`.
  fullWidth?: boolean
}) {
  if (!hasHScroll) return null
  return (
    <div className="fixed bottom-0 left-0 right-0 z-20 pointer-events-none">
      <div className={fullWidth ? 'w-full px-6' : 'container mx-auto px-4'}>
        <div
          ref={mirrorRef}
          onScroll={onScroll}
          className="pointer-events-auto overflow-x-auto overflow-y-hidden h-3 bg-gray-100 dark:bg-gray-900 border border-b-0 border-gray-200 dark:border-gray-700 rounded-t-lg shadow-[0_-2px_6px_rgba(0,0,0,0.08)]"
          aria-hidden="true"
        >
          <div style={{ width: scrollWidth }} className="h-px" />
        </div>
      </div>
    </div>
  )
}
